import { StateSchema } from 'app/config/storeConfig/types';
import { AuthResponse } from '../types';

export const getCredentials = (state: StateSchema): Nullable<AuthResponse> => state.user.credentials;
